// @flow

import React from 'react'
import styled, { css } from 'styled-components'
import { fontSize } from 'frontend_core/dist/styles/variables'
import { mediaMax } from 'frontend_core/dist/styles/media'

function switchPositionType(positionType) {
  if (positionType === 'left') {
    return 'right'
  } else if (positionType === 'right') {
    return 'left'
  }

  return ''
}

const IconComponent = styled.i`
  font-size: ${fontSize.small__25}px;
  ${({ positionType }) =>
    positionType &&
    css`
    margin-${switchPositionType(positionType)}: 4px;
  `}
  ${({ iconSize }) =>
    iconSize &&
    css`
      font-size: ${iconSize}px;
    `}
  ${({ iconSizeSp }) =>
    iconSizeSp &&
    css`
      ${mediaMax.phone`
      font-size: ${iconSizeSp}px;
    `};
    `}
  color: ${props => props.color};
`

type PropTypes = {
  className?: string,
  type: string,
  positionType?: 'left' | 'right',
  iconSize?: number,
  iconSizeSp?: number,
  color?: string,
}

export default function Icon(props: PropTypes) {
  return (
    <IconComponent
      className={
        props.className ? props.className : `fa fa-${props.type || ''}`
      }
      positionType={props.positionType}
      iconSize={props.iconSize}
      iconSizeSp={props.iconSizeSp}
      color={props.color}
    />
  )
}
